import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";


export const Promotion_service = {
    addPromotion,
    saveExcel,
    savePdf,
    previewPromotions,
    removePdf,
    searchPromotion,
    searchPopularPromotion,
    setProvider,
    removePromotion,
    findHistory,
    importPromotions,
    setObjExcel,
    getProportionMobileRate,
    getProportionMobileType,
    getServiceRegulate,
    sendRequest,
    getAdminById,
    getAvailableMonthlyRegulate,
    getPromotionByRevision
};

function addPromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/addPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function saveExcel(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/saveExcel/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function savePdf(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/savePdf/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function importPromotions(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/importPromotions/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}


function previewPromotions(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/previewPromotions/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function searchPromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/searchPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function searchPopularPromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/searchPopularPromotion/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function removePdf(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    axios.post(config.API_URL + "promotion/removePdf/?authorization=" + json_cookie.token, { path_file: data })
}

function setProvider() {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "promotion/setProvider/" + json_cookie.provider_id + "/?authorization=" + json_cookie.token).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function removePromotion(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/removePromotion/?authorization=" + json_cookie.token, data).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function findHistory(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/getPromotionHistory/?authorization=" + json_cookie.token, data).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function setObjExcel(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/setObjExcel/?authorization=" + json_cookie.token, data).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getProportionMobileRate(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportG2/getProportionMobileRate/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getProportionMobileType(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportG2/getProportionMobileType/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getServiceRegulate(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportG2/getServiceRegulate/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function sendRequest(formdata){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "manage_request/addMobileChangeRequest/?authorization=" + json_cookie.token, formdata).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getAdminById(formdata){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "admin/getAdminById/?authorization=" + json_cookie.token, formdata).then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getAvailableMonthlyRegulate(provider_id){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/getAvailableMonthlyRegulate/?authorization=" + json_cookie.token, provider_id)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getPromotionByRevision(data){
    let json_cookie = JSON.parse(Cookie.get('user_nbtc'))
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "promotion/getPromotionByRevision/?authorization=" + json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}